import {Calculator, Check, Clock, RotateCcw} from '@nlabs/gothamjs/icons';

import type {ReactElement} from 'react';

const activity = [
  {amount: '$1.20', icon: Clock, shot: 'Shot 03', status: 'Reserved', tone: 'text-amber-200'},
  {amount: '$0.80', icon: Check, shot: 'Shot 02', status: 'Spent', tone: 'text-violet-200'},
  {amount: '$1.00', icon: RotateCcw, shot: 'Shot 01', status: 'Returned', tone: 'text-sky-200'}
];

export const CreditHistoryVisual = (): ReactElement => (
  <>
    <div className="mb-3 flex items-center justify-between text-[9px] leading-3 tracking-[.14em] text-white/55"><span>ESTIMATE & ACTIVITY</span><span className="tracking-normal text-violet-300">Example</span></div>
    <div className="flex h-16 items-center gap-2.5 rounded-xl border border-violet-300/30 bg-violet-300/10 px-3">
      <Calculator className="shrink-0 text-violet-300" size={20} />
      <div className="min-w-0 flex-1"><p className="text-[10px] leading-3.5 text-violet-100">Next generation</p><p className="mt-1 text-[8px] leading-3 text-white/55">Review before you submit</p></div>
      <div className="text-right"><p className="text-[8px] leading-3 text-violet-300">Estimate</p><p className="mt-1 text-base leading-5 text-white tabular-nums">$1.20</p></div>
    </div>
    <p className="mt-3 mb-1 text-[9px] leading-3 text-white/55">Credit history</p>
    <ul className="divide-y divide-white/10">{activity.map(({amount, icon: Icon, shot, status, tone}) => (
      <li className="flex h-8 items-center gap-2" key={shot}>
        <Icon className={`shrink-0 ${tone}`} size={12} />
        <span className={`text-[10px] leading-3 ${tone}`}>{status}</span>
        <span className="text-[9px] leading-3 text-white/40">{shot}</span>
        <span className="ml-auto text-[11px] leading-3 text-white/80 tabular-nums">{amount}</span>
      </li>
    ))}</ul>
  </>
);
